module.exports = __webpack_public_path__ + "static/media/icon_trash.a01b04d1.svg";